interface TableDownloadCYVisitReceiptCellProps {
  visitId: number;
  priceSum: number;
  children?: React.ReactNode;
}

import { DownloadCollectionYardVisitReceipt, DownloadVariant } from "../DownloadCollectionYardVisitReceipt";

import styles from "./TableDownloadCYVisitReceiptCell.module.scss";

export const TableDownloadCYVisitReceiptCell: React.FC<TableDownloadCYVisitReceiptCellProps> = ({
  visitId,
  priceSum,
  children,
}) => {
  return (
    <div className={styles.receiptCell}>
      {children}
      {priceSum > 0 && <DownloadCollectionYardVisitReceipt visitId={visitId} variant={DownloadVariant.icon} />}
    </div>
  );
};
